export default __webpack_public_path__ + "static/media/section3-bg-left.3f8a2e0d.png";